import createMountedApp from './utils/create-mounted-app';
import { computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, createElementVNode, createCommentVNode, createBlock, toDisplayString, normalizeStyle, renderSlot, Fragment, renderList } from 'vue';
import { createComponent } from './utils/create-component';
import { isFunction } from './utils/validate';
import { addPxUnit } from './utils/format';
import { INPUT_EVENT, SHOW_EVENT, HIDE_EVENT } from './utils/constants';
import Popup from './popup';
import Icon from './icon';
import propTypes from './utils/prop-types';
import { noop } from './utils/function';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * 弹窗是否可见
   */
  modelValue: propTypes["boolean"]().def(false),
  /**
   * 窗口标题
   */
  title: propTypes.string(),
  /**
   * 弹窗的内容（用于简单内容，复杂内容请使用slot）支持 HTML
   */
  content: propTypes.string(),
  /**
   * 弹窗内容行数，超出滚动
   */
  contentRows: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(9),
  /**
   * 底部操作按钮组（最多支持两个）
   */
  btns: propTypes.array(),
  /**
   * 是否有蒙层
   */
  showMask: propTypes["boolean"]().def(true),
  /**
   * 点击蒙层是否可关闭弹窗
   */
  maskCloseable: propTypes["boolean"]().def(true),
  /**
   * 弹窗位置
   */
  position: propTypes.string().def('center'),
  /**
   * 弹窗动画
   */
  transition: propTypes.string().def('dialog-transition'),
  /**
   * 是否禁止滚动穿透
   */
  disableScroll: propTypes["boolean"]().def(true),
  /**
   * 是否将弹窗移动至body节点
   */
  transferDom: propTypes["boolean"]().def(true),
  /**
   * 移到body节点下的弹出层的class
   */
  popupClass: propTypes.string().def(''),
  /**
   * 是否显示右上角关闭按钮
   */
  closeable: propTypes["boolean"]().def(false)
};
var emits = [INPUT_EVENT, SHOW_EVENT, HIDE_EVENT];

var _components;
var _createComponent = createComponent('dialog'),
  create = _createComponent.create,
  className = _createComponent.className;
// 内容区域行高
var CONTENT_LINE_HEIGHT = 24;
var script = create({
  components: (_components = {}, _defineProperty(_components, Popup.name, Popup), _defineProperty(_components, Icon.name, Icon), _components),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    // 根据 props.modelValue 控制弹窗显示/隐藏
    var dialogShow = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set() {
        return onClose();
      }
    });
    var titleClasses = computed(function () {
      var hasContent = props.content || slots["default"];
      return ["".concat(className, "__title"), !hasContent && "".concat(className, "__title-no-content")];
    });
    var contentStyle = computed(function () {
      var maxHeight = +props.contentRows * CONTENT_LINE_HEIGHT;
      return {
        maxHeight: addPxUnit(maxHeight)
      };
    });
    /**
     * @description: button click 底部按钮点击
     * @param {*}
     * @return {*}
     */
    function onBtnClick(btn) {
      if (isFunction(btn.handler)) {
        btn.handler();
      } else {
        onClose();
      }
    }
    /**
     * @description: button click 右上角关闭按钮点击
     * @param {*}
     * @return {*}
     */
    function onClose() {
      emit(INPUT_EVENT, false);
    }
    function onShow() {
      emit(SHOW_EVENT);
    }
    function onHide() {
      emit(HIDE_EVENT);
    }
    return {
      slots: slots,
      dialogShow: dialogShow,
      className: className,
      titleClasses: titleClasses,
      contentStyle: contentStyle,
      onBtnClick: onBtnClick,
      onShow: onShow,
      onHide: onHide,
      onClose: onClose
    };
  }
});

var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_icon = resolveComponent("sp-icon");
  var _component_sp_popup = resolveComponent("sp-popup");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createVNode(_component_sp_popup, {
    modelValue: _ctx.dialogShow,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.dialogShow = $event;
    }),
    showMask: _ctx.showMask,
    maskCloseable: _ctx.maskCloseable,
    position: _ctx.position,
    transition: _ctx.transition,
    disableScroll: _ctx.disableScroll,
    transferDom: _ctx.transferDom,
    popupClass: _ctx.popupClass,
    onShow: _ctx.onShow,
    onHide: _ctx.onHide
  }, {
    "default": withCtx(function () {
      return [createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__container"))
      }, [createCommentVNode(" 右上角关闭icon "), _ctx.closeable ? (openBlock(), createBlock(_component_sp_icon, {
        key: 0,
        name: "dialog_colse",
        size: "24",
        "class": normalizeClass("".concat(_ctx.className, "__close")),
        onClick: _ctx.onClose
      }, null, 8 /* PROPS */, ["class", "onClick"])) : createCommentVNode("v-if", true), createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__body"))
      }, [createCommentVNode(" 标题 "), _ctx.title ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": normalizeClass(_ctx.titleClasses)
      }, toDisplayString(_ctx.title), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true), createCommentVNode(" 内容 "), _ctx.content ? (openBlock(), createElementBlock("div", {
        key: 1,
        "class": normalizeClass("".concat(_ctx.className, "__content")),
        style: normalizeStyle(_ctx.contentStyle),
        innerHTML: _ctx.content,
        ref: "contentRef"
      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1)) : createCommentVNode("v-if", true), _ctx.slots["default"] ? (openBlock(), createElementBlock("div", {
        key: 2,
        "class": normalizeClass("".concat(_ctx.className, "__slot"))
      }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */), createCommentVNode(" 操作区域 "), _ctx.btns && _ctx.btns.length > 0 ? (openBlock(), createElementBlock("footer", {
        key: 1,
        "class": normalizeClass("".concat(_ctx.className, "__actions"))
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.btns.slice(0, 2), function (btn, index) {
        return openBlock(), createElementBlock("div", {
          "class": normalizeClass("".concat(_ctx.className, "__actions_btn")),
          key: index,
          onClick: function onClick($event) {
            return _ctx.onBtnClick(btn);
          }
        }, toDisplayString(btn.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_2);
      }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)];
    }),

    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "showMask", "maskCloseable", "position", "transition", "disableScroll", "transferDom", "popupClass", "onShow", "onHide"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/dialog/dialog.vue";

var generate = function generate() {
  var _listeners;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instance = createMountedApp(script, {
    appendToBody: true,
    propsData: _objectSpread2({
      modelValue: true
    }, props),
    listeners: (_listeners = {}, _defineProperty(_listeners, INPUT_EVENT, function (val) {
      instance.updatePropsData({
        modelValue: val
      });
    }), _defineProperty(_listeners, SHOW_EVENT, function () {
      props && props.onShow && props.onShow();
    }), _defineProperty(_listeners, HIDE_EVENT, function () {
      props && props.onHide && props.onHide();
      instance.app.unmount();
    }), _listeners)
  });
  return instance;
};
// 确认弹窗方法（底部为两个按钮的情况）
script.confirm = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  props = Object.assign({
    confirmText: '确定',
    cancelText: '取消'
  }, props);
  var onCancel = props.onCancel || noop;
  var onConfirm = props.onConfirm || noop;
  var instance = generate(Object.assign({
    btns: [{
      text: props.cancelText,
      handler: function handler() {
        onCancel();
        instance.updatePropsData({
          modelValue: false
        });
      }
    }, {
      text: props.confirmText,
      handler: function handler() {
        if (onConfirm() !== false) {
          instance.updatePropsData({
            modelValue: false
          });
        }
      }
    }]
  }, props));
  return instance;
};
// 警告弹窗方法（底部为一个按钮的情况）
script.alert = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  props = Object.assign({
    confirmText: '确定'
  }, props);
  var onConfirm = props.onConfirm || noop;
  var instance = generate(Object.assign({
    btns: [{
      text: props.confirmText,
      handler: function handler() {
        if (onConfirm() !== false) {
          instance.updatePropsData({
            modelValue: false
          });
        }
      }
    }]
  }, props));
  return instance;
};
var _DialogAlert = script;

export { _DialogAlert as default };
